import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { Point } from "pixi.js";
/**
 * A container which can move focus around its children to act as a camera rig.
 */
export class AbstractCameraRig extends AbstractGameView {
    handleRotate(event) {
        super.handleRotate(event);
        if (this.uiProperties?.name) {
            this.name = this.uiProperties.name;
        }
    }
    /**
     * Move the focus by changing the rig's position and pivot simultaneously.
     */
    moveFocus(x, y) {
        this.position.set(x, y);
        this.position.copyTo(this.pivot);
    }
    /**
     * Move the focus to the centre of the game.
     */
    recentreFocus() {
        const offset = new Point(this.uiProperties?.position?.x ?? 0, this.uiProperties?.position?.y ?? 0);
        const size = this.renderer.getGameSize();
        this.moveFocus(size.x / 2 + offset.x, size.y / 2 + offset.y);
    }
}
//# sourceMappingURL=AbstractCameraRig.js.map